import { render, staticRenderFns } from "./NfeReceivedList.vue?vue&type=template&id=470b99ea&scoped=true&"
import script from "./NfeReceivedList.vue?vue&type=script&lang=js&"
export * from "./NfeReceivedList.vue?vue&type=script&lang=js&"
import style0 from "./NfeReceivedList.vue?vue&type=style&index=0&id=470b99ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470b99ea",
  null
  
)

export default component.exports